import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  DashboardWrapper,
  LoadingInTabWrapper,
} from "../../../style/DashbordWidgetWrappers";
import { IconLoading } from "../../../config/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DashboardF1Summary,
  useLazyGetF1PracticesSummaryByTenantQuery,
} from "../../../redux/apiSpecifications/apiCrud";
import { RootState } from "../../../redux/store";
import { setInfoAlwaysVisibleTop } from "../../../redux/features/userSlice";
import { mainTabs as testIds } from "../../../config/testIds";
import CustomerList from "../../Widgets/Customer/CustomerList";
import { AggregateSummaryDataF1 } from "./common-utils";
import dekra from "../../../style/dekra";
import { useAuthorization } from "../../../hooks/useAuthorization";
import Loading from "../../Loading";

const DashboardF1Wrapper = styled(DashboardWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1em;

  .buttonStyle {
    background: ${dekra.primaryColor};
    border-radius: 10px;
    color: #fff;
    text-transform: uppercase;
    padding: 0px 2rem;
    text-align: right;
    border: none;
  }
`;

const DashboardRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

interface IDashBoard_F1Props {
  tabKey?: number;
}

const DashBoard_F1 = (props: IDashBoard_F1Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [retrieveSummaryData] = useLazyGetF1PracticesSummaryByTenantQuery();

  const { selectedTenants, authorization } = useSelector(
    (state: RootState) => state.user
  );
  const { activeKey } = useSelector((state: RootState) => state.mainTabs);

  const [loadingStatus, setLoadingStatus] = useState<
    "idle" | "loading" | "refreshing"
  >("idle");

  const [allData, setAllData] = useState<DashboardF1Summary>();

  useEffect(() => {
    if (activeKey === props.tabKey) {
      setLoadingStatus("refreshing");
      (async () => {
        await loadSummary();
      })();
    }
  }, [activeKey]);

  const loadSummary = async () => {
    if (!selectedTenants) return;
    dispatch(
      setInfoAlwaysVisibleTop({
        type: "empty",
        message: "",
      })
    );

    const tenantsSummaryData: DashboardF1Summary[] = [];

    for (let tenant of selectedTenants) {
      const idTenant = tenant.id!;

      const response = await retrieveSummaryData({
        idTenant,
        authorization: authorization,
      });
      const { data, error, isSuccess, isError } = response;

      if (isSuccess && data) {
        tenantsSummaryData.push(data as DashboardF1Summary);
      } else if (isError) {
        dispatch(
          setInfoAlwaysVisibleTop({
            type: "error",
            message: t("http-error-loading-dashboard"),
          })
        );
        setLoadingStatus("idle");
        return;
      } else {
        console.log("unknown error");
      }
    }

    const aggregateSummaryDataF1 = AggregateSummaryDataF1(tenantsSummaryData);
    setAllData(aggregateSummaryDataF1 as DashboardF1Summary);
    setLoadingStatus("idle");
  };

  useEffect(() => {
    setLoadingStatus("loading");
    loadSummary();
  }, [selectedTenants]);

  return (
    <div data-testid={testIds.dashboards.F1}>
      {loadingStatus === "loading" && (
        <LoadingInTabWrapper>
           <Loading />
        </LoadingInTabWrapper>
      )}
      {(loadingStatus === "refreshing" || loadingStatus === "idle") &&
        allData && (
          <>
            <DashboardF1Wrapper>
              <DashboardRow>
                <CustomerList
                  items={allData?.practices}
                  isActive={activeKey === props.tabKey}
                />
              </DashboardRow>
            </DashboardF1Wrapper>
          </>
        )}
    </div>
  );
};

export default DashBoard_F1;
